module.exports = __webpack_public_path__ + "static/img/illustratepic_01.f587900.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zh-TW/illustratepic_01.png
// module id = REVE
// module chunks = 1